import { render, staticRenderFns } from "./switch-icon.vue?vue&type=template&id=6c0d8ca4&scoped=true"
import script from "./switch-icon.vue?vue&type=script&lang=js"
export * from "./switch-icon.vue?vue&type=script&lang=js"
import style0 from "./switch-icon.vue?vue&type=style&index=0&id=6c0d8ca4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0d8ca4",
  null
  
)

export default component.exports